/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { WrappedError } from "abweb/utils/error/WrappedError";

// Below is OO version with ErrorContext with two concrete subclasses: TaskQueueErrorContext, MicroTaskErrorContext
// Could have also had a single ErrorContext with a 'union' of the fields, with all fields that aren't in both optional.

export class ErrorContext {
  /** Strongly typed Error instance.  Will be a 'WrappedError' if they threw a non-Error value (e.g., a string)
   * The moduleErrorInfo will only be supplied if the exception was thrown from the task queue (aka ui thread);
   * it is NOT available for exceptions thrown from the micro-task queue (promise chains)
   */
  constructor(error, moduleInfo) {
    this.error = error;
    this.moduleInfo = moduleInfo;
  }
  static createFromErrorEvent(errEvt) {
    return new ErrorContext(WrappedError.errorFactory(errEvt.error ?? new Error(`ErrorEvent: ${errEvt.message}`)),
    // errEvt.message is redundant with errEvt.error.message, so skip it so as to have single SOR for 'message'
    new ModuleErrorInfo(errEvt.filename, errEvt.lineno, errEvt.colno));
  }
  static createFromPromiseRejectionEvent(pre) {
    return new ErrorContext(
    // Do not have a use case for saving pre.promise, so skipping it for now
    WrappedError.errorFactory(pre.reason), null);
  }

  /** Create error context from an error obtained from a catch block argument */
  static createFromError(errUntyped) {
    return new ErrorContext(
    // Do not have a use case for saving pre.promise, so skipping it for now
    WrappedError.errorFactory(errUntyped), null);
  }
}
export class ModuleErrorInfo {
  constructor(filename, lineno, colno) {
    this.filename = filename;
    this.lineno = lineno;
    this.colno = colno;
  }
}

// Explored OO, but consumers would have to know to do 'errCtx instanceof FooErrorContext' in order to get
// access to specialized members.

// Explored union class where all members common to both events are required (error), and all others are optional.
// This bites as it forces developer to reason about each individual member.  The above ErrorContext is a compromise
// in that all 'optional' members are in single struct (ModuleErrorInfo), so dev only has to check for null or not.
//# sourceMappingURL=ErrorContext.js.map
